import { Component, Input, OnInit } from '@angular/core';
import IGISDataCacheIteratorStatistic = ZoningAPI.IGISDataCacheIteratorStatistic;
import * as _ from 'lodash';

@Component({
    standalone: false,
    selector: 'app-process-cache-statistic',
    templateUrl: './process-cache-statistic.component.html',
    styleUrls: ['./process-cache-statistic.component.scss']
})
export class ProcessCacheStatisticComponent implements OnInit {
    @Input()
    cacheStatistic: IGISDataCacheIteratorStatistic;

    constructor() {}

    get isUploadRequired(): boolean {
        return _.get(this, 'cacheStatistic.isUploadRequired', false);
    }

    get isIteratorDone(): boolean {
        return _.get(this, 'cacheStatistic.isIteratorDone', false);
    }

    get cacheSize(): number {
        return _.get(this, 'cacheStatistic.cacheSize', 0);
    }

    get maxCacheSize(): number {
        return _.get(this, 'cacheStatistic.maxCacheSize', 1);
    }

    ngOnInit(): void {}

    getColor(): string {
        return this.isIteratorDone || !this.isUploadRequired ? 'primary' : 'warn';
    }

    getValue(): number {
        return Math.floor((this.cacheSize / this.maxCacheSize) * 100);
    }

    getStatusClass(): string {
        return this.isIteratorDone ? 'done' : 'in-progress';
    }
}
